import { createMachine, assign } from 'xstate';
import { uuid } from 'vue-uuid';
import {validZipCodesSolar} from "@/data/validZipCodesPv";
import {validZipCodesWP} from "@/data/validZipCodesWp";


import { transformContactFormDataForApi } from '@/utils/apiTransformer';

// Importe der ausgelagerten Aktionen
import {
    setStateHistory,
    sendVlinkDataAction,
    sendDataToGateway,
    updateBuildingTypeData,
    updateOwnerData,
    updateAlreadyBuiltData,
    updatePowerConsumersData,
    updateWishPowerStorageData,
    updateWishHeatpumpData,
    updateWishWallboxData,
    storeAddressData,
    updatePlannedReplacementData,
    updateAppointmentTypeData,
    storeContactFormData,
    clearErrorMessage,
    sendTrackingPostMessage,
    trackConversion,
    //redirectParentDirectly,
} from '@/utils/workflowMachineActions';
export const workflowMachine = createMachine({
    id: 'workflow',
    initial: 'buildingTypeQuestion',
    context: {
        appSessionId: uuid.v4(),
        fromState: "Geladen",
        toState: "Frage: Gebäudetyp",
        fromMachineState: "Initial", // Maschinenzustand
        toMachineState: "buildingTypeQuestion", // Maschinenzustand
        qualifikation: {
            buildingType: { apiDefinition: null, apiValue: null, },
            owner: { apiDefinition: null, apiValue: null, },
            alreadyBuilt: { apiDefinition: null, apiValue: null, },
            planned_replacement: { apiDefinition: null, apiValue: null, },
            power_consumers: { apiDefinition: null, apiValue: null, },
            wishPowerStorage: { apiDefinition: null, apiValue: null, },
            wishWallbox: { apiDefinition: null, apiValue: null, },
            wishHeatpump: { apiDefinition: null, apiValue: null, },
        },
        formData: {
            building: {
                zip: null, city: null, street: null, houseNumber: null,
                type: null, owner: false, year: null, planned_replacement: null, already_built: false,
                power_consumers: [], wish_power_storage: null, wishWallbox: null, wish_heatpump: null,
            },
            contactForm: null,
            contactFormApiData: null,
            submissionResultData: null,
        },
        transitionCount: 0,
        errorMessage: null,
        crossdomainId: '',
        levetoSource: '',
        levetoMedium: '',
        levetoChannel: 'ON',
        apiFieldErrors: null,
        vertriebskanal: '',
    },
    on: {
        CLEAR_API_ERRORS: {
            actions: assign({apiFieldErrors: null, errorMessage: null}), // Setzt alle API-Fehler auf null
        },
    },
    states: {
        zipCodeQuestion: {
            on: {
                NEXT: [
                    { actions: storeAddressData, target: 'powerConsumersQuestion', guard: 'isZipCodeValid', },
                    { actions: storeAddressData, target: 'zipCodeNotAvailable', },
                ],
                BACK: { target: 'alreadyBuiltQuestion', },
            },
        },
        powerConsumersQuestion: {
            on: {
                UPDATE_SELECTED_POWER_CONSUMERS: {actions: updatePowerConsumersData},
                NEXT: [
                    { actions: updatePowerConsumersData, target: 'wishPowerStorageQuestion'},
                ],
                BACK: { target: 'zipCodeQuestion', },
            },
        },
        wishPowerStorageQuestion: {
            on: {
                UPDATE_SELECTED_WISH_POWER_STORAGE_ANSWER: { actions: updateWishPowerStorageData, },
                NEXT: [
                    { actions: updateWishPowerStorageData, target: 'wishWallboxQuestion', },
                ],
                BACK: { target: 'powerConsumersQuestion', },
            },
        },
        wishWallboxQuestion: {
            on: {
                UPDATE_SELECTED_WISH_WALLBOX_ANSWER: { actions: updateWishWallboxData, },
                NEXT: [
                    { actions: updateWishWallboxData, guard: 'isHeatPumpQuestionAvailable', target: 'wishHeatpumpQuestion', },
                    { actions: updateWishWallboxData, target: 'plannedReplacementQuestion', },
                ],
                BACK: { target: 'wishPowerStorageQuestion', },
            },
        },
        buildingTypeQuestion: {
            on: {
                UPDATE_SELECTED_BUILDING_TYPE: { actions: updateBuildingTypeData, },
                NEXT: [
                    { actions: updateBuildingTypeData, target: 'ownerQuestion', guard: 'isBuildingTypeAvailable', },
                    { actions: updateBuildingTypeData, target: 'buildingTypeNotAvailable', },
                ],
            },
        },
        ownerQuestion: {
            on: {
                UPDATE_SELECTED_OWNER_ANSWER: { actions: updateOwnerData, },
                NEXT: [
                    { actions: updateOwnerData, target: 'alreadyBuiltQuestion', guard: 'isOwnerAvailable', },
                    { actions: updateOwnerData, target: 'ownerNotAvailable', },
                ],
                BACK: { target: 'buildingTypeQuestion', },
            },
        },
        alreadyBuiltQuestion: {
            on: {
                UPDATE_SELECTED_ALREADY_BUILT_ANSWER: { actions: updateAlreadyBuiltData, },
                NEXT: [
                    { actions: updateAlreadyBuiltData, guard: 'isAlreadyBuiltAvailable', target: 'zipCodeQuestion', },
                    { actions: updateAlreadyBuiltData, target: 'buildingYearNotAvailable', },
                ],
                BACK: { target: 'ownerQuestion', },
            },
        },

        plannedReplacementQuestion: {
            on: {
                UPDATE_SELECTED_PLANNED_REPLACEMENT_ANSWER: { actions: updatePlannedReplacementData, },
                NEXT: [
                    { actions: updatePlannedReplacementData, guard: 'isAppointmentQuestionAvailable', target: 'appointmentTypeQuestion', },
                    { actions: updatePlannedReplacementData, target: 'contactInformationQuestion', },
                ],
                BACK: [
                    { guard: 'isHeatPumpQuestionAvailable', target: 'wishHeatpumpQuestion' },
                    { target: 'wishWallboxQuestion', }
                ],
            }
        },
        appointmentTypeQuestion: {
            on: {
                UPDATE_SELECTED_APPOINTMENT_TYPE: {actions: updateAppointmentTypeData},
                NEXT: [
                    { actions: updateAppointmentTypeData, target: 'contactInformationQuestion'},
                ],
                BACK: [
                    { target: 'plannedReplacementQuestion' },
                ],
            }
        },
        wishHeatpumpQuestion: {
            on: {
                UPDATE_SELECTED_WISH_HEATPUMP_ANSWER: { actions: updateWishHeatpumpData, },
                NEXT: [
                    { actions: updateWishHeatpumpData, target: 'plannedReplacementQuestion', },
                ],
                BACK: { target: 'wishWallboxQuestion', },
            },
        },
        contactInformationQuestion: {
            entry: ['setVertriebskanal'],
            on: {
                CONTACT_FORM_SUBMITTED: {
                    actions: [storeContactFormData, transformContactFormDataForApi],
                    target: 'sendingData'
                },
                BACK: [
                    { guard: 'isAppointmentQuestionAvailable', target: 'appointmentTypeQuestion', },
                    { target: 'plannedReplacementQuestion' },
                ],
            }
        },
        sendingData: {
            entry: [ clearErrorMessage, 'sendDataAction' ],
            on: {
                VLINK_SUBMISSION_SUCCESS: {
                    target: 'submissionSuccess',
                    actions: [
                        assign({ errorMessage: null }),
                        assign({ apiFieldErrors: null }),
                        assign({ formData: ({ context, event }) => ({ ...context.formData, submissionResultData: event.payload }) }),
                        //redirectParentDirectly
                    ],
                },
                VLINK_SUBMISSION_FAILED: {
                    target: 'contactInformationQuestion',
                    actions: assign({
                        errorMessage: ({ event }) => {
                            console.error('Fehler vom VLINK_SUBMISSION_FAILED Event:', event.error);
                            return event.error.message || 'Ein Fehler ist beim Senden des Kontaktformulars aufgetreten.';
                        },
                        apiFieldErrors: ({ event }) => {
                            return event.error.fieldErrors || null; // Speichert die feldspezifischen Fehler
                        },
                    }),
                },
            },
        },
        submissionSuccess: {
            entry: [
                assign({ errorMessage: null }),
                assign({ apiFieldErrors: null }),
                'trackConversion',
                ],
            on: {
                RESET_WORKFLOW: {
                    target: 'buildingTypeQuestion', // Zurück zum initialen State
                },
            },
        },
        zipCodeNotAvailable: { on: { BACK: 'zipCodeQuestion' } },
        buildingTypeNotAvailable: { on: { BACK: 'buildingTypeQuestion' } },
        ownerNotAvailable: {  on: { BACK: 'ownerQuestion' } },
        buildingYearNotAvailable: { on: { BACK: 'alreadyBuiltQuestion' } },
    },
}, {
    actions: {
        sendDataAction: (params) => {
            const endpoint = process.env.VUE_APP_ENDPOINT;

            if (endpoint === 'leveto') {
                sendDataToGateway(params);
            } else if (endpoint === 'vlink') {
                sendVlinkDataAction(params);
            } else {
                console.warn(`Unbekannter Endpoint: "${endpoint}". Keine Daten gesendet.`);
            }
        },
        updateBuildingTypeData,
        updateOwnerData,
        storeAddressData,
        updateAlreadyBuiltData,
        updateAppointmentTypeData,
        storeContactFormData,
        clearErrorMessage,
        transformContactFormDataForApi,
        setStateHistory,
        sendTrackingPostMessage,
        trackConversion,
        setVertriebskanal: assign(({ context}) => {
            const isFeatureEnabled = process.env.VUE_APP_APPOINTMENT_QUESTION === 'true';
            if (isFeatureEnabled) {
                return;
            }
            const levetoChannel = context.levetoChannel;

            if (levetoChannel !== "ON") {
                return {
                    formData: {
                        ...context.formData,
                        building: { ...(context.formData.building || {}), appointment: 'onsite' }
                    },
                    vertriebskanal: process.env.VUE_APP_VERTRIEBSKANAL,
                };
            }
            return {
                formData: {
                    ...context.formData,
                    building: { ...(context.formData.building || {}), appointment: 'online' }
                },
                vertriebskanal: process.env.VUE_APP_VERTRIEBSKANAL,
            };
        }),
    },
    guards: {
        isZipCodeValid: ({event}) => {
            const inputZipCode = String(event.data.zip);
            return inputZipCode in validZipCodesSolar;
        },
        isHeatPumpQuestionAvailable: ({context}) => {
            const { zip, power_consumers } = context.formData.building;
            const isZipValidForWP = zip in validZipCodesWP;
            const hasNotSelectedHeatpump = !power_consumers.includes('waermepumpe');
            return isZipValidForWP && hasNotSelectedHeatpump;
        },
        isBuildingTypeAvailable: ({event}) => { const { available } = event.data; return available; },
        isOwnerAvailable: ({event}) => { const { available } = event.data; return available; },
        isAlreadyBuiltAvailable: ({event}) => { const { available } = event.data; return available; },
        isAppointmentQuestionAvailable: ({context}) => {
            const isFeatureEnabled = process.env.VUE_APP_APPOINTMENT_QUESTION === 'true';
            if (!isFeatureEnabled) {
                return false;
            }
            return context.levetoChannel !== "ON";
        },
    }
});